import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `
    <div class="loading" *ngIf="showContent">
      <span [ngStyle]="{ 'height.px': size, 'width.px': size }"></span>
      <span [ngStyle]="{ 'height.px': size, 'width.px': size }"></span>
      <span [ngStyle]="{ 'height.px': size, 'width.px': size }"></span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [require('./loader.component.scss')],
})
export class LoaderComponent implements OnInit, OnDestroy {
  @Input() size = '8';
  @Input() delay = 0;
  @HostBinding('class') @Input() class = '';

  showContent = false;
  delayLoader;

  constructor(private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.delayLoader = setTimeout(() => this.show(), this.delay);
  }

  ngOnDestroy() {
    clearTimeout(this.delayLoader);
  }

  private show() {
    this.showContent = true;
    this.cd.markForCheck();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/loader/loader.component.ts